import { render, staticRenderFns } from "./RecommendListItem.vue?vue&type=template&id=08ea8489"
import script from "./RecommendListItem.vue?vue&type=script&lang=js"
export * from "./RecommendListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports